import { Component } from "@angular/core";

@Component({
  selector: "ngx-one-column-layout",
  styleUrls: ["./one-column.layout.scss"],
  template: `
    <nb-layout windowMode>
      <nb-layout-header fixed>
        <ngx-header></ngx-header>
      </nb-layout-header>

      <nb-sidebar class="menu-sidebar" tag="menu-sidebar" responsive start>
        <ng-content select="nb-menu"></ng-content>
      </nb-sidebar>

      <!-- <nb-sidebar cog tag="cog-sidebar" state="collapsed" fixed>
        <ngx-cog-settings></ngx-cog-settings>
      </nb-sidebar> -->
      <nb-layout-column>
        <!-- <div
          class="ngx-toggle-setting-container "
          [ngClass]="!sidebarCollapsed ? 'position-end expanded' : ''"
          (click)="toggle()"
          *ngIf="!hideCogSettings"
        >
          <button nbButton id="cog-button">
            <nb-icon icon="cog" id="cog-icon"></nb-icon>
          </button>
        </div> -->

        <ng-content select="router-outlet"></ng-content>
      </nb-layout-column>

      <!-- <nb-layout-footer fixed>
        <ngx-footer></ngx-footer>
      </nb-layout-footer> -->
    </nb-layout>
  `,
})
export class OneColumnLayoutComponent {}
